
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ApiGrid extends Serenity.EntityGrid<ApiRow, any> {
        protected getColumnsKey() { return ApiColumns.columnsKey; }
        protected getDialogType() { return ApiDialog; }
        protected getIdProperty() { return ApiRow.idProperty; }
        protected getInsertPermission() { return ApiRow.insertPermission; }
        protected getLocalTextPrefix() { return ApiRow.localTextPrefix; }
        protected getService() { return ApiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}